var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column-edit-size" },
    [
      _c("el-input", {
        attrs: { type: "number", size: "mini", "data-index": "overLeft" },
        on: { input: _vm.handleChange },
        model: {
          value: _vm.overLeft,
          callback: function($$v) {
            _vm.overLeft = _vm._n($$v)
          },
          expression: "overLeft"
        }
      }),
      _c("span", [_vm._v("-")]),
      _c("el-input", {
        attrs: { type: "number", size: "mini", "data-index": "overRight" },
        on: { input: _vm.handleChange },
        model: {
          value: _vm.overRight,
          callback: function($$v) {
            _vm.overRight = _vm._n($$v)
          },
          expression: "overRight"
        }
      }),
      _c("span", [_vm._v("-")]),
      _c("el-input", {
        attrs: { type: "number", size: "mini", "data-index": "overFront" },
        on: { input: _vm.handleChange },
        model: {
          value: _vm.overFront,
          callback: function($$v) {
            _vm.overFront = _vm._n($$v)
          },
          expression: "overFront"
        }
      }),
      _c("span", [_vm._v("-")]),
      _c("el-input", {
        attrs: { type: "number", size: "mini", "data-index": "overBack" },
        on: { input: _vm.handleChange },
        model: {
          value: _vm.overBack,
          callback: function($$v) {
            _vm.overBack = _vm._n($$v)
          },
          expression: "overBack"
        }
      }),
      _c("span", [_vm._v("-")]),
      _c("el-input", {
        attrs: { type: "number", size: "mini", "data-index": "overHeight" },
        on: { input: _vm.handleChange },
        model: {
          value: _vm.overHeight,
          callback: function($$v) {
            _vm.overHeight = _vm._n($$v)
          },
          expression: "overHeight"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }